import { template as template_a74961040b334b669e22669c8b7d259e } from "@ember/template-compiler";
import ButtonPowerSelect from 'eflex/components/button-power-select';
import { get } from '@ember/helper';
export default template_a74961040b334b669e22669c8b7d259e(`
<ButtonPowerSelect
  @options={{@options}}
  @triggerClass={{@triggerClass}}
  @placeholder={{@placeholder}}
  @disabled={{@disabled}}
  @extra={{@extra}}
  @searchEnabled={{@searchEnabled}}
  @searchField={{@searchField}}
  @ariaDescribedBy={{@ariaDescribedBy}}
  @onChange={{@onChange}}
  ...attributes
as |option select|>
  {{#if (has-block)}}
    {{yield option select}}
  {{else}}
    {{#if @optionLabelPath}}
      {{get option @optionLabelPath}}
    {{else}}
      {{option}}
    {{/if}}
  {{/if}}
</ButtonPowerSelect>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
